import { render } from "./DashUserLimit.vue?vue&type=template&id=c27e5cbc&scoped=true"
import script from "./DashUserLimit.vue?vue&type=script&lang=js"
export * from "./DashUserLimit.vue?vue&type=script&lang=js"

import "./DashUserLimit.vue?vue&type=style&index=0&id=c27e5cbc&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27e5cbc"]])

export default __exports__